<template>
  <div class="page-wrapper" v-loading="loading">
    <el-row :gutter="10">
      <el-col :sm="24" :md="8" v-for="section in sections" :key="section.id">
        <el-card
          class="box-card"
          shadow="never"
          v-if="section.title == 'CallNumber'"
        >
          <div slot="header" class="clearfix">
            <span>Call Number</span>
            <div style="float: right; padding: 3px 0">
              <el-button size="small" @click="onRefresh">刷新</el-button>
              <el-button type="primary" size="small" @click="onSave"
                >保存</el-button
              >
            </div>
          </div>
          <el-form
            ref="form"
            :model="section"
            label-width="120px"
            label-position="top"
            :disabled="submitting"
          >
            <el-row :gutter="10">
              <el-col :sm="24" :md="24">
                <el-form-item label="联系方式">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    placeholder="请输入内容"
                    v-model="section.content"
                  >
                  </el-input> </el-form-item
              ></el-col>
            </el-row>
          </el-form>
        </el-card>
        <el-card
          class="box-card"
          shadow="never"
          v-if="section.title == 'ContactInfo'"
        >
          <div slot="header" class="clearfix">
            <span>Contact Info </span>
            <div style="float: right; padding: 3px 0">
              <el-button size="small" @click="onRefresh">刷新</el-button>
              <el-button type="primary" size="small" @click="onSave"
                >保存</el-button
              >
            </div>
          </div>
          <el-form
            ref="form"
            :model="section"
            label-width="120px"
            label-position="top"
            :disabled="submitting"
          >
            <el-row :gutter="10">
              <el-col :sm="24" :md="24">
                <el-form-item label="邮件">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    placeholder="请输入内容"
                    v-model="section.content"
                  >
                  </el-input> </el-form-item
              ></el-col>
            </el-row>
          </el-form>
        </el-card>
        <el-card
          class="box-card"
          shadow="never"
          v-if="section.title == 'Address'"
        >
          <div slot="header" class="clearfix">
            <span>Address </span>
            <div style="float: right; padding: 3px 0">
              <el-button size="small" @click="onRefresh">刷新</el-button>
              <el-button type="primary" size="small" @click="onSave"
                >保存</el-button
              >
            </div>
          </div>
          <el-form
            ref="form"
            :model="section"
            label-width="120px"
            label-position="top"
            :disabled="submitting"
          >
            <el-row :gutter="10">
              <el-col :sm="24" :md="24">
                <el-form-item label="地址">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    placeholder="请输入内容"
                    v-model="section.content"
                  >
                  </el-input> </el-form-item
              ></el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  GetPagesById,
  GetPagesSectionsById,
  PutPagesById,
} from "@/views/pagesManager/api";
import { ShowApiError } from "@/request/error";
export default {
  name: "ContactUs",
  data() {
    return {
      loading: false,
      submitting: false,
      currentPageId: 8,
      sections: [],
      page: {
        name: "",
        parentId: null,
        title: "",
        sub_title: "",
        description: "",
        icon: "",
        sections: [],
        seq: null,
        hidden: null,
      },
    };
  },
  created() {
    this.initSetting();
  },
  methods: {
    initSetting() {
      this.loading = true;
      GetPagesById(this.currentPageId)
        .then((res) => {
          for (const key in res.data) {
            if (Object.hasOwnProperty.call(this.page, key)) {
              this.page[key] = res.data[key];
            }
          }
          return GetPagesSectionsById(this.currentPageId);
        })
        .then((res) => {
          this.sections = res.data;
        })
        .catch((err) => {
          ShowApiError(err, "获取页面信息失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSave() {
      let sectionData = this.sections.map((item) => {
        if (item.title == "CallNumber") {
          item.seq = 0;
        }
        if (item.title == "ContactInfo") {
          item.seq = 1;
        }
        if (item.title == "Address") {
          item.seq = 2;
        }
        return item;
      });
      let _form = {
        ...this.page,
        sections: [...sectionData],
      };
      this.submitting = true;
      PutPagesById(this.currentPageId, _form)
        .then(() => {
          this.$message.success("保存成功");
          this.initSetting();
        })
        .catch((err) => {
          ShowApiError(err, "保存失败");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    onRefresh() {
      this.initSetting();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
}
.box-card {
  margin: 10px 0;
}
.banner-list-wrap {
  width: 100%;
  ::v-deep {
    .transition-el {
      min-height: 330px;
    }
  }
}
::v-deep {
  .custom-draggable {
    max-width: 100%;
  }
}
.patent-item {
  display: block;
  width: 200px;
  height: 300px;
  margin: 5px;
}
.about-us-image {
  width: 100%;
  max-width: 450px;
  height: 260px;
  ::v-deep {
    .img-upload-wrapper {
      height: auto;
    }
    .uploaded-img-preview {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.add-madias-item {
  text-align: center;
}
</style>
